import React from 'react'
import Navbar from '../components/Navbar';
import github from '../assets/github_logo.png';
import linkedin from '../assets/linkedin_logo.png';
import hackerrank from '../assets/hackerrank_logo.png';
import leetcode from '../assets/leetcode_logo.png';
// import youtube from '../assets/YT_logo.png';
import '../styles/CommonStyle.css';
import Links from '../components/Links';
import { useEffect } from 'react';


export default function Home() {

  useEffect(() => {
    const scroller = document.body
    scroller.scrollIntoView({ behavior: 'smooth' })
    scroller.scrollTo(0, 0)
  }, []);

  return (<>
    <div className="NavbarStyle" >
      <Navbar />
    </div>

    <div className='homecontainer'>
      <div className='homecontents'>
        <div className='homecontentsfont'>
          Hello, I'm&nbsp;<span id='wordchanger'>ADcode</span>

        </div>
        <div className='secondhomecontentsfont'>
          I want to learn about programming
        </div>

        <div id="links" className='links secondhomecontentsfont' style={{
          display: "flex", flexDirection: "row", width: "100%", flexWrap: "wrap",
          alignItems: "center"
        }}>
          <div style={{
            display: "flex", width: "25%",
            flexDirection: "row", justifyContent: "space-between", alignItems: "center"
          }}>
            <div>
              <Links htmlUrl="https://github.com/Ankurcr7"
                imageUrl={github} name="GitHub" classname="links-images github" />
            </div>
            <div>
              <Links htmlUrl="https://www.linkedin.com/in/ankur-das-42471023b/"
                imageUrl={linkedin} name="LinkedIn" classname="links-images linkedin" />
            </div>
            <div>
              <Links htmlUrl="https://www.hackerrank.com/profile/ankurdas140905"
                imageUrl={hackerrank} name="HackerRank" classname="links-images hackerrank" />
            </div>
            <div>
              <Links htmlUrl="https://leetcode.com/u/isADcode/"
                imageUrl={leetcode} name="LeetCode" classname="links-images leetcode" />
            </div>
            {/* <div>
              <Links htmlUrl="https://www.youtube.com/channel/UCxyD54EBTfdSpW318tlLcXg"
                imageUrl={youtube} name="YouTube" classname="links-images youtube" />
            </div> */}

          </div>


        </div>
      </div>

    </div>

    <footer className='footer_'>
      <div style={{ height: " inherit", display: "flex", flexDirection: "column" , justifyContent:"center", alignItems:"center", flexWrap:"wrap"}}>
  
        <div style={{textAlign:"center"}}>
          Made with React application by Ankur Das
        </div>
      </div>

    </footer>


  </>

  )
}
